import _isEmpty from 'lodash/isEmpty';
import _property from 'lodash/property';

// Formatters
import { getCustomerName, getCustomerId } from '@tekion/tekion-base/formatters/customer';

// Reader
import customerReader from '@tekion/tekion-base/readers/Customer';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { tget } from '@tekion/tekion-base/utils/general';
var getCustomerOptionLabel = function getCustomerOptionLabel() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var shouldShowExternalId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var customerData = tget(option, 'data', option);
  if (_isEmpty(customerData)) {
    return '';
  }
  if (customerData.label) return customerData.label;
  var customerName = getCustomerName(customerData) || '';
  var customerId = getCustomerId(customerData) || '';
  var email = customerReader.email(customerData) || '';
  var externalId = customerReader.externalId(customerData) || '';
  if (shouldShowExternalId && !_isEmpty(externalId)) return "".concat(customerId, " (").concat(externalId, ") - ").concat(customerName, " ").concat(email);
  return "".concat(customerId, " - ").concat(customerName, " ").concat(email);
};
var getCustomerOptionValue = _property('id');
var CUSTOMER_OPTION_CONFIG = {
  getOptionLabel: getCustomerOptionLabel,
  getOptionValue: getCustomerOptionValue
};
export default CUSTOMER_OPTION_CONFIG;